import Swal from 'sweetalert2';

const SwalService = {
  // Mostrar una alerta simple
  async alert(title = '¡Alerta!', text = '', icon = 'info') {
    return Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: 'Aceptar',
      showLoaderOnConfirm: false,
      customClass: {
        confirmButton: 'btn-custom',
      },
    });
  },

  // Confirmación con dos opciones (Aceptar/Cancelar)
  async confirm(
    title = '¿Estás seguro?',
    text = '',
    icon = 'warning',
    confirmButtonText = 'Sí',
    cancelButtonText = 'No'
  ) {
    return Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      customClass: {
        confirmButton: 'btn-custom',
        cancelButton: 'btn-custom-cancel',
      },
    });
  },

  // Mostrar un mensaje de éxito
  async success(title = '¡Éxito!', text = '') {
    return Swal.fire({
      title,
      text,
      icon: 'success',
      confirmButtonText: 'Aceptar',
      customClass: {
        confirmButton: 'btn-custom',
      },
    });
  },

  // Mostrar un mensaje de error
  async error(title = 'Error', text = '') {
    return Swal.fire({
      title,
      text,
      icon: 'error',
      confirmButtonText: 'Aceptar',
      customClass: {
        confirmButton: 'btn-custom',
      },
    });
  },

  // Mostrar un mensaje de carga
  async loading(title = 'Cargando...', text = '') {
    Swal.fire({
      title,
      text,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  },

  // Cerrar SweetAlert
  close() {
    Swal.close();
  },

  // Personalizar completamente la alerta
  async customAlert(options = {}) {
    return Swal.fire({
      ...options,
    });
  },
};

export default SwalService;
